import React, { useContext, useEffect, useState, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { graphql, useStaticQuery } from 'gatsby'
import PageContext from '../../contexts/pageContext'
import { checkHasAuthorizationToCategory } from '../../helpers/authorization'
import LanguageContext from '../../contexts/languageContext'
import { AuthContext } from '../../contexts/authContext'
import { SideMenuContext } from '../../contexts/sideMenuContext'
import { ResponsiveContext } from '../../contexts/responsiveContext'
import SidebarFooter from '../../components/Sidebar/SidebarFooter'
import * as Helpers from './helpers'
import SideMenuItem from './SideMenuItem'
import styles from './styles.module.css'
import Tag from '../Tag'

const Sidemenu = () => {
  const { t } = useTranslation()
  const [navGroup, setNavGroup] = useState([])
  const [resources, setResources] = useState([])
  const { navYaml, allFile } = useStaticQuery(query)
  const { page } = useContext(PageContext)
  const { lang } = useContext(LanguageContext)
  const { user, resourceAllowed, isLoading: isAuthLoading } = useContext(AuthContext)
  const { isMobile } = useContext(ResponsiveContext)
  const { menuStates, isMenuOpen, handleUserNavigation } = useContext(SideMenuContext)
  const { isFixedOpen } = menuStates
  const categories = useMemo(() => ({ home: 'home', changelog: 'changelog' }), [])
  const homePath = useMemo(() => `/${lang}/`, [lang])
  const changelogPath = useMemo(() => `/${lang}/${categories.changelog}`, [lang, categories.changelog])

  useEffect(() => {
    const navGroupBuilded = Helpers.buildNavGroup(navYaml, allFile, page, lang)

    setNavGroup(navGroupBuilded)
  }, [navYaml, allFile, page, lang])

  useEffect(() => {
    if (!isAuthLoading) {
      setResources(resourceAllowed)
    }
  }, [resourceAllowed, isAuthLoading])

  return (
    <nav className={`${styles.fixed} ${isMobile ? (isFixedOpen ? styles.fixedOpen : styles.fixedClosed) : styles.fixedOpen}`}>
      <div
        role="menubar"
        aria-orientation="vertical"
        className={`${styles.menu} ${isMobile ? (isMenuOpen ? styles.menuOpen : styles.menuClosed) : styles.menuOpen}`}
        {...handleUserNavigation}
      >
        <ul className="_p-2 _flex-1 _hot-scroll">
          <SideMenuItem key={categories.home} category={categories.home} path={homePath}>
            {t(`categories.${categories.home}.title`)}
          </SideMenuItem>
          {navGroup.map(({ category, items }) => {
            const isTutorial = category === 'tutorials'
            const hasPermissionToCategory = checkHasAuthorizationToCategory(items, user, resources)
            return (
              hasPermissionToCategory && (
                <SideMenuItem key={category} category={category} items={items} resources={resources} >
                  {t(`categories.${category}.title`)}
                  {isTutorial && <Tag class="hot-tag--blue hot-tag--sm">{t('general.new')}</Tag>}
                </SideMenuItem>
              )
            )
          })}
          <SideMenuItem key={categories.changelog} category={categories.changelog} path={changelogPath}>
            Changelog
          </SideMenuItem>
        </ul>
        <footer>
          <SidebarFooter />
        </footer>
      </div>
    </nav>
  )
}

const query = graphql`
  {
    navYaml {
      nav {
        footer {
          items {
            page
          }
        }
        menu {
          category
          items {
            page
          }
        }
      }
    }
    allFile(filter: { ext: { eq: ".md" }, absolutePath: { regex: "//content//" } }) {
      edges {
        node {
          name
          childMarkdownRemark {
            fields {
              langKey
              slug
            }
            frontmatter {
              title
            }
          }
        }
      }
    }
  }
`

export default Sidemenu
